var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.type != 5
      ? _c(
          "div",
          {
            staticClass: "item",
            on: {
              click: function ($event) {
                return _vm.lookDetails(_vm.item.courseLink || _vm.item.link)
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "img",
                class: { img2: _vm.type == 2 || _vm.type == 3 },
              },
              [
                _c("img", {
                  attrs: {
                    src:
                      _vm.fileUrl(
                        _vm.item.courseImage || _vm.item.previewPic
                      ) || _vm.img,
                  },
                }),
                _vm._v(" "),
                _vm.type == 1 || _vm.type == 2
                  ? _c(
                      "div",
                      {
                        staticClass: "leb leb1",
                        class: {
                          leb1sj:
                            _vm.item.courseLevel == "省级" ||
                            _vm.item.majorLevel == "省级",
                          leb1yx:
                            _vm.item.courseLevel == "校级" ||
                            _vm.item.majorLevel == "校级",
                        },
                      },
                      [
                        _vm._v(
                          "\r\n        " +
                            _vm._s(
                              _vm.item.courseLevel || _vm.item.majorLevel
                            ) +
                            "\r\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.type == 1 || _vm.type == 2
                  ? _c("div", { staticClass: "leb leb2" }, [_vm._v("北京")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.type == 3
                  ? _c("div", { staticClass: "leb3" }, [
                      _vm._v(_vm._s(_vm.item.courseTypeName)),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mainText", class: { mainTextBg: _vm.type == 4 } },
              [
                _c("div", { staticClass: "coursetit" }, [
                  _vm._v(_vm._s(_vm.item.courseName || _vm.item.name || "---")),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "school" }, [
                  _vm._v(
                    _vm._s(
                      _vm.item.fkCourseEmceeSchool ||
                        _vm.item.emceeCompanyname ||
                        ""
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticClass: "sourse" }, [
                    _c("div", { staticClass: "text_w" }, [
                      _vm._v(_vm._s(_vm.item.industry || "---")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sourse" }, [
                    _c("div", { staticClass: "text_w" }, [
                      _vm._v(_vm._s(_vm.item.industryDetailName || "---")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sourse" }, [
                    _c("div", { staticClass: "text_w" }, [
                      _vm._v(
                        _vm._s(
                          _vm.item.fkCourseMajor || _vm.item.majorId || "---"
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "line2" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "sourse" }, [
                    _c("div", { staticClass: "text" }, [
                      _vm._v("来源: " + _vm._s(_vm.item.origin || "---")),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.type == 5
      ? _c(
          "div",
          {
            staticClass: "item2",
            on: {
              click: function ($event) {
                return _vm.lookDetails(_vm.item.courseLink || _vm.item.link)
              },
            },
          },
          [
            _vm.type == 5
              ? _c("div", { staticClass: "img5" }, [
                  _c("img", {
                    attrs: {
                      src:
                        _vm.fileUrl(
                          _vm.item.courseImage || _vm.item.previewPic
                        ) || _vm.img,
                    },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.type == 5
              ? _c("div", { staticClass: "mainText" }, [
                  _c("div", { staticClass: "coursetitTest" }, [
                    _vm._v(
                      _vm._s(_vm.item.courseName || _vm.item.name || "---")
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "sourse" }, [
                      _c("div", { staticClass: "sourseTest" }, [
                        _vm._v(_vm._s(_vm.item.origin || "---")),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }